import { gql } from '@apollo/client';

const DASHBOARD_GET_PRODUCT_EDE_APP = gql`
  query DashboardGetProductEdeApp($applicationId: ID!) {
    getProductEdeApp(applicationId: $applicationId) {
      id
      insuranceApplicationIdentifier
      coverageYear
      coverageState
      applicationId
    }
  }
`;

export default DASHBOARD_GET_PRODUCT_EDE_APP;
